export const STARTUP_LOADER_KEY = 'etc-site-loader-seen-v3';
export const STARTUP_LOADER_LAST_SEEN_AT_KEY = 'etc-site-loader-last-seen-at-v1';
export const STARTUP_LOADER_IDLE_RESET_MS = 1000 * 60 * 60 * 24 * 7; // 7 days
export const ENTRANCE_PREVIEW_QUERY_KEY = 'entrancePreview';
export const ENTRANCE_PREVIEW_QUERY_VALUE = '1';

export function isEntrancePreviewPath(asPath = '') {
  const raw = String(asPath || '');
  const queryIndex = raw.indexOf('?');
  if (queryIndex === -1) return false;

  const hashIndex = raw.indexOf('#', queryIndex);
  const query = raw.slice(queryIndex + 1, hashIndex === -1 ? undefined : hashIndex);
  return new URLSearchParams(query).get(ENTRANCE_PREVIEW_QUERY_KEY) === ENTRANCE_PREVIEW_QUERY_VALUE;
}

function getStartupLoaderStorages() {
  if (typeof window === 'undefined') {
    return [];
  }

  const storages = [];

  try {
    if (window.localStorage) {
      storages.push(window.localStorage);
    }
  } catch {
    // Some browsers block persistent storage in private contexts.
  }

  try {
    if (window.sessionStorage) {
      storages.push(window.sessionStorage);
    }
  } catch {
    // Ignore if session storage is unavailable too.
  }

  return storages;
}

export function hasSeenStartupLoader() {
  const now = Date.now();
  let hasSeen = false;

  for (const storage of getStartupLoaderStorages()) {
    try {
      if (storage.getItem(STARTUP_LOADER_KEY) !== '1') continue;

      hasSeen = true;
      const rawLastSeenAt = storage.getItem(STARTUP_LOADER_LAST_SEEN_AT_KEY);
      const lastSeenAt = Number(rawLastSeenAt);
      const isLastSeenValid = Number.isFinite(lastSeenAt) && lastSeenAt > 0;
      const isExpired = !isLastSeenValid || now - lastSeenAt > STARTUP_LOADER_IDLE_RESET_MS;

      if (isExpired) {
        storage.removeItem(STARTUP_LOADER_KEY);
        storage.removeItem(STARTUP_LOADER_LAST_SEEN_AT_KEY);
        continue;
      }

      // Keep the session fresh while the user keeps visiting.
      storage.setItem(STARTUP_LOADER_LAST_SEEN_AT_KEY, String(now));
    } catch {
      // Ignore storage read/write issues and keep app behavior resilient.
    }
  }

  return hasSeen && getStartupLoaderStorages().some((storage) => storage.getItem(STARTUP_LOADER_KEY) === '1');
}

export function markStartupLoaderSeen() {
  const now = String(Date.now());
  for (const storage of getStartupLoaderStorages()) {
    try {
      storage.setItem(STARTUP_LOADER_KEY, '1');
      storage.setItem(STARTUP_LOADER_LAST_SEEN_AT_KEY, now);
    } catch {
      // Ignore write failures and keep the app usable.
    }
  }
}

export function clearStartupLoaderSeen() {
  for (const storage of getStartupLoaderStorages()) {
    try {
      storage.removeItem(STARTUP_LOADER_KEY);
      storage.removeItem(STARTUP_LOADER_LAST_SEEN_AT_KEY);
    } catch {
      // Ignore write failures and keep the app usable.
    }
  }
}
